import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, fromEvent, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  standalone: true
})
export class TextAreaComponent  implements ControlValueAccessor {

  //#region Propiedades

  @ViewChild("dvContenido") public dvContenido: ElementRef<HTMLElement>
  @Input("label") public label: string
  private valueObservable = new BehaviorSubject<string>("")
  @Output("valueChange") public valueChange = new EventEmitter<{newValue: string, oldValue: string}>()
  @Input("value") public set value(val: string) {
    this.valueObservable.next(val)
  }

  //#endregion

  //#region Constructor

  constructor(
    @Self() @Optional() private control: NgControl
  ) {
    if (this.control != null) {
      this.control.valueAccessor = this
    }
  }

  private destroy$ = new Subject<void>()
  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  //#endregion

  //#region Load

  ngAfterViewInit(): void {
    let textArea = document.createElement('textarea')
    textArea.classList.add('custom-textarea')
    textArea.style.resize = 'none'
    textArea.rows = 4
    fromEvent(textArea, 'blur').pipe(
      takeUntil(this.destroy$)
    ).subscribe(async () => {
      let oldValue = await firstValueFrom(this.valueObservable)
      let newValue = textArea.value
      if (newValue != oldValue) {
        this.valueObservable.next(newValue)
      }
      this.onChange(newValue)
      this.valueChange.emit({oldValue: oldValue, newValue: newValue})
    });
    ['input', 'keydown', 'keypress', 'keyup'].forEach(p => fromEvent(textArea, p).pipe(
      takeUntil(this.destroy$)
    ).subscribe((e) => {
      e.stopPropagation()
      e.stopImmediatePropagation()
    }))
    this.valueObservable.pipe(
      takeUntil(this.destroy$)
    ).subscribe((v) => {
      textArea.value = v
    })
    this.dvContenido.nativeElement.append(textArea)
  }

  //#endregion

  //#region Reactive Forms

  private onChange = (value: string) => {}
  private onTouched = () => {}

  writeValue(value: string): void {
    firstValueFrom(this.valueObservable).then(oldValue => {
      this.valueObservable.next(value)
      this.valueChange.emit({newValue: value, oldValue: oldValue})
      this.onChange(value)
    })
  }

  registerOnChange(fn: (value: string) => {}): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn
  }

  //#endregion

}
